import Vue from "vue";
import { getInstance } from "./authWrapper";
import { getDashboardTitle, getDashboardType } from "@/helpers/dashboard-name-helper";
import { getItem } from "@/helpers/storage-manager";
import { ability } from "@/helpers/abilities";
import store from "@/store/store";

export const authGuard = (to, from, next) => {
  const authService = getInstance();

  const hasRulesInStorage = function () {
    let currentTime = (new Date()).getTime()

    let rulesExists = Boolean(getItem('rules') && Array.isArray(getItem('rules')) && getItem('rules').length)
    let needsUpdate = Math.round((currentTime - (getItem('rulesUpdatedTime') || 0)) / 1000) > 60 * 15

    return rulesExists && !needsUpdate
  }

  const fn = async () => {
    try {
      document.title = getDashboardTitle(getDashboardType())
    } catch (e) { }

    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (!authService.isAuthenticated) {
        console.log('asking to login, not auth');
        return await authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
        //return next({ name: 'logout', query: { redirect: window.location.origin + to.path }, params: to.params })
      }

      if(authService.isAuthenticated && (!Vue.prototype.$getCookie('user') || !Vue.prototype.$getCookie('user').role_id)) {
        await store.dispatch('auth/admin')
        await store.dispatch('auth/role')
      }

      if (!ability.rules.length) {
        if (hasRulesInStorage()) {
          store.commit('auth/updatePermissions', getItem('rules'))
        } else {
          try {
            await store.dispatch('auth/admin')
            await store.dispatch('auth/role')
          } catch (e) {
            console.error(e.message)
            Vue.prototype.$message.error('Ocurrió un error validando la sesión.')
            // return await authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
            return next({ name: 'logout', params: to.params })
          }
        }
      }
    }

    if (to.meta.resource) {
      try {
        if (!ability.can('read', to.meta.resource)) {
          Vue.prototype.$message.error('No tienes acceso a esta sección')
          if (to.params.account_id) {
            next({ name: 'PluginsLoader', params: to.params })
          } else {
            next({ name: 'root' })
          }
        }
      } catch (e) {
        console.error(e.message)
      }
    }

    if (to.name === 'organizations' && !ability.can('read', 'organization')) {
      return next('dashboard/accounts')
    }

    return next();
    //authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
  };

  if (!authService.loading) {
    return fn();
  }

  authService.$watch("loading", loading => {
    if (loading === false) {
      return fn();
    }
  });
};
